import { render } from "./FacturacionPage.vue?vue&type=template&id=295b50ac"
import script from "./FacturacionPage.vue?vue&type=script&lang=js"
export * from "./FacturacionPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__